import * as React from 'react';
import styled from 'styled-components';

import { useContentScroll } from '../../../hooks/useContentScroll';
import { AnimatedComponent } from '../AnimatedComponent';

const MobileSearchContainer = styled.div`
  overflow: hidden;
`;

type Props = {
  searchInput: React.ReactNode;
};

export const MobileSearchInput: React.FC<Props> = ({ searchInput }) => {
  const contentScroll = useContentScroll();
  return (
    <AnimatedComponent
      isVisible={contentScroll === 0}
      animate={{ y: '0px' }}
      exit={{ y: '-36px', transition: { duration: 0.15 } }}
      motionRootContainer={MobileSearchContainer}
    >
      {searchInput}
    </AnimatedComponent>
  );
};
